module.exports = __webpack_public_path__ + "img/HC2012-38.b0174b5d.jpg";